<div class="container-fluid dashboard-shell" *ngIf="dashboardView !== 'fortune'">
  <div class="dashboard-header mb-4">
    <div class="dashboard-brand">
      <img src="assets/images/logo-dark.png" alt="Logo" class="logo">
      <div class="header-copy">
        <span class="eyebrow">Fortune Backoffice</span>
        <h2>{{ dashboardView === 'fusionLease' ? 'Fusion Lease Dashboard' : 'Board Sales Dashboard' }}</h2>
        <p>
          {{ dashboardView === 'fusionLease'
            ? 'Lease performance, contracts, allocated machines, and board statistics.'
            : 'Board sales performance, contracts, allocated machines, and board statistics.' }}
        </p>
      </div>
    </div>
    <div class="header-actions">
      <a class="btn btn-outline-primary" routerLink="/dashboard-selector">
        <i class="fas fa-th-large me-2"></i>Switch Dashboard
      </a>
    </div>
  </div>

  <div class="section-heading">
    <div>
      <h5>Performance Overview</h5>
      <p>Daily statistics for this operation only.</p>
    </div>
  </div>

  <div class="analytics-cards performance-grid">
    <div class="analytics-card" (click)="toggleOperationTable('stats')">
      <div class="card-body">
        <div class="metric-icon"><i class="fas fa-dollar-sign"></i></div>
        <ng-container *ngIf="dashboardView === 'fusionLease'; else boardSalesMetric">
          <h6 class="metric-label">Fusion Lease Cash In / Day</h6>
          <h2 class="metric-value">{{ fusionLeaseSummary.cashIn | currency:'USD':'symbol':'1.2-2' }}</h2>
          <h6 class="metric-label mt-3">Fusion Lease Net / Day</h6>
          <h2 class="metric-value">{{ fusionLeaseSummary.net | currency:'USD':'symbol':'1.2-2' }}</h2>
          <span class="badge bg-success">{{ fusionLeaseSummary.rows }} rows</span>
        </ng-container>
        <ng-template #boardSalesMetric>
          <h6 class="metric-label">Board Sales Cash In / Day</h6>
          <h2 class="metric-value">{{ boardSalesSummary.cashIn | currency:'USD':'symbol':'1.2-2' }}</h2>
          <h6 class="metric-label mt-3">Board Sales Net / Day</h6>
          <h2 class="metric-value">{{ boardSalesSummary.net | currency:'USD':'symbol':'1.2-2' }}</h2>
          <span class="badge bg-primary">{{ boardSalesSummary.rows }} rows</span>
        </ng-template>
      </div>
    </div>

    <div class="analytics-card" (click)="toggleOperationTable('contracts')">
      <div class="card-body">
        <div class="metric-icon"><i class="fas fa-file-signature"></i></div>
        <h6 class="metric-label">Active Contracts</h6>
        <h2 class="metric-value">
          {{ dashboardView === 'fusionLease' ? leaseContractCount : boardSalesContractCount }}
        </h2>
        <span class="badge bg-success">Allocated contracts</span>
      </div>
    </div>

    <div class="analytics-card" (click)="toggleOperationTable('machines')">
      <div class="card-body">
        <div class="metric-icon"><i class="fas fa-microchip"></i></div>
        <h6 class="metric-label">Total Machine Count</h6>
        <h2 class="metric-value">
          {{ dashboardView === 'fusionLease' ? leaseMachineCount : boardSalesMachineCount }}
        </h2>
        <span class="badge bg-info text-dark">Allocated machines</span>
      </div>
    </div>
  </div>

  <div class="row filter-toolbar g-3 align-items-end my-4" *ngIf="operationTable === 'stats'">
    <div class="col-md-3">
      <label>Start Date</label>
      <input class="form-control" ngbDatepicker #operationStart="ngbDatepicker"
             [(ngModel)]="statsStartDate" (dateSelect)="onDateChange()" (click)="operationStart.toggle()">
    </div>
    <div class="col-md-3">
      <label>End Date</label>
      <input class="form-control" ngbDatepicker #operationEnd="ngbDatepicker"
             [(ngModel)]="statsEndDate" (dateSelect)="onDateChange()" (click)="operationEnd.toggle()">
    </div>
    <div class="col-md-3">
      <label>Search</label>
      <input class="form-control" [(ngModel)]="activeSearchTerm"
             (ngModelChange)="onSearchDebounced($event)" placeholder="Game, rep, or location">
    </div>
    <div class="col-md-3">
      <label>Board / Serial</label>
      <input class="form-control" [(ngModel)]="activeBoardSearchTerm"
             (ngModelChange)="onBoardSearchDebounced($event)" placeholder="Asset tag or serial">
    </div>
  </div>

  <div class="card analytics-card table-card mt-4" *ngIf="operationTable === 'contracts'">
    <div class="card-body">
      <h4 class="card-title mb-4">
        {{ dashboardView === 'fusionLease' ? 'Fusion Lease Active Contracts' : 'Board Sales Active Contracts' }}
      </h4>
      <div class="table-responsive breakdown-table">
        <table class="table table-bordered table-hover">
          <thead>
            <tr class="table-info totals-row">
              <th colspan="5"><strong>Total Contracts ({{ activeOperationLocations.length }})</strong></th>
              <th><strong>{{ dashboardView === 'fusionLease' ? leaseMachineCount : boardSalesMachineCount }}</strong></th>
            </tr>
            <tr>
              <th>Location</th>
              <th>Sales Rep</th>
              <th>State</th>
              <th>Contract Start</th>
              <th>Contract End</th>
              <th>Machines</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let loc of activeOperationLocations; trackBy: trackByLocation">
              <td>{{ loc.locationName }}</td>
              <td>{{ loc.salesRep?.firstName }} {{ loc.salesRep?.lastName }}</td>
              <td>{{ loc.businessAddress?.state || '-' }}</td>
              <td>{{ loc.locationStartDate | date }}</td>
              <td>{{ loc.locationEndDate | date }}</td>
              <td>{{ loc.numBoards || 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="card analytics-card table-card mt-4" *ngIf="operationTable === 'machines'">
    <div class="card-body">
      <h4 class="card-title mb-4">
        {{ dashboardView === 'fusionLease' ? 'Fusion Lease Machine Allocation' : 'Board Sales Machine Allocation' }}
      </h4>
      <div class="table-responsive breakdown-table">
        <table class="table table-bordered table-hover">
          <thead>
            <tr class="table-info totals-row">
              <th colspan="3"><strong>Allocated Machine Total</strong></th>
              <th>
                <strong>{{ dashboardView === 'fusionLease' ? leaseMachineCount : boardSalesMachineCount }}</strong>
              </th>
            </tr>
            <tr>
              <th>Location</th>
              <th>Sales Rep</th>
              <th>State</th>
              <th>Machine Count</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let loc of activeOperationLocations; trackBy: trackByLocation">
              <td>{{ loc.locationName }}</td>
              <td>{{ loc.salesRep?.firstName }} {{ loc.salesRep?.lastName }}</td>
              <td>{{ loc.businessAddress?.state || '-' }}</td>
              <td>{{ loc.numBoards || 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-container *ngIf="dashboardView === 'fusionLease' && operationTable === 'stats'">
    <app-sales-rep-game-stats
      title="Fusion Lease Board Stats" groupBy="salesRep" tableFormat="boardStats"
      currentCategory="FUSION_LEASE" [allowedNames]="fusionLeaseSalesReps"
      [boardStats]="fusionLeaseValidStats" [startDate]="startDate" [endDate]="endDate"
      [isRoot]="isRoot" (categoryChange)="moveStatToCategory($event.stat, $event.category)"
      (flagChange)="onDedicatedFlagChange($event)" (deleteStat)="deleteRow($event)">
    </app-sales-rep-game-stats>
    <app-sales-rep-game-stats
      *ngIf="fusionLeaseFlaggedStats.length" title="Flagged Fusion Lease Board Stats"
      [flagged]="true" groupBy="salesRep" tableFormat="boardStats" currentCategory="FUSION_LEASE"
      [allowedNames]="fusionLeaseSalesReps" [boardStats]="fusionLeaseFlaggedStats"
      [startDate]="startDate" [endDate]="endDate" [isRoot]="isRoot"
      (categoryChange)="moveStatToCategory($event.stat, $event.category)"
      (flagChange)="onDedicatedFlagChange($event)" (deleteStat)="deleteRow($event)">
    </app-sales-rep-game-stats>
  </ng-container>

  <ng-container *ngIf="dashboardView === 'boardSales' && operationTable === 'stats'">
    <app-sales-rep-game-stats
      title="Board Sales Stats" groupBy="salesRep" tableFormat="boardStats"
      currentCategory="BOARD_SALES" [allowedNames]="[]" [boardStats]="boardSalesValidStats"
      [startDate]="startDate" [endDate]="endDate" [isRoot]="isRoot"
      (categoryChange)="moveStatToCategory($event.stat, $event.category)"
      (flagChange)="onDedicatedFlagChange($event)" (deleteStat)="deleteRow($event)">
    </app-sales-rep-game-stats>
    <app-sales-rep-game-stats
      *ngIf="boardSalesFlaggedStats.length" title="Flagged Board Sales Stats"
      [flagged]="true" groupBy="salesRep" tableFormat="boardStats" currentCategory="BOARD_SALES"
      [allowedNames]="[]" [boardStats]="boardSalesFlaggedStats"
      [startDate]="startDate" [endDate]="endDate" [isRoot]="isRoot"
      (categoryChange)="moveStatToCategory($event.stat, $event.category)"
      (flagChange)="onDedicatedFlagChange($event)" (deleteStat)="deleteRow($event)">
    </app-sales-rep-game-stats>
  </ng-container>
</div>

<div class="container-fluid dashboard-shell" *ngIf="dashboardView === 'fortune'">
  <div class="dashboard-header mb-4">
    <div class="dashboard-brand">
      <img src="assets/images/logo-dark.png" alt="Logo" class="logo">
      <div class="header-copy">
        <span class="eyebrow">Fortune Backoffice</span>
        <h2>Dashboard Overview</h2>
        <p>Track sales performance, live Fortune activity, machines, and operations in one place.</p>
      </div>
    </div>

    <div class="header-actions">
      <a class="btn btn-outline-primary me-2"
         routerLink="/inventory"
         *ngIf="currentUserType === 'ROOT'">
        <i class="fas fa-boxes me-2"></i>Inventory
      </a>
      <a class="btn btn-outline-primary me-2"
         routerLink="/dashboard-selector"
         *ngIf="currentUserType === 'ROOT' || currentUserType === 'INTERNAL'">
        <i class="fas fa-th-large me-2"></i>
        Switch Dashboard
      </a>
      <button class="btn btn-primary report-btn" (click)="openBoardStatsReport()" *ngIf="showStatsReport">
        <i class="fas fa-chart-bar me-2"></i>
        Board Statistics Report
      </button>
    </div>
  </div>

  <div class="section-heading">
    <div>
      <h5>Performance Overview</h5>
      <p>Daily metrics and live production trends.</p>
    </div>
  </div>

  <div class="analytics-cards performance-grid">
    <!-- Cash In Per Day Card -->
<!-- Cash In & Net Per Day Card -->
<div class="analytics-card" (click)="setActiveFilterContext('regular'); toggleTable('stats')" *ngIf="hasRegularStatsCard">
  <div class="card-body">
    <div class="notification-icon" (click)="markStatsAsSeen()">
      <div class="metric-icon">
        <i class="fas fa-dollar-sign"></i>
        <span *ngIf="unseenStatsCount > 0" class="badge">{{ unseenStatsCount }}</span>
      </div>
    </div>    

    <h6 class="metric-label">Cash In Per Day</h6>
    <h2 class="metric-value" *ngIf="!boardStatsCardLoading; else boardStatsLoadingValue">
      ${{averageCashInPerDayPerFilteredBoard.toFixed(2)}}
    </h2>

    <h6 class="metric-label mt-3">Net Per Day</h6>
    <h2 class="metric-value" *ngIf="!boardStatsCardLoading; else boardStatsLoadingValue">
      ${{averageNetPerDayPerFilteredBoard.toFixed(2)}}
    </h2>
    <ng-template #boardStatsLoadingValue>
      <h2 class="metric-value text-muted">Loading...</h2>
    </ng-template>
  </div>

        <div class="trend-indicator positive">
          <i class="fas fa-arrow-up"></i>
          <span>Average</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-chart-line"></i>
          Daily Average
        </span>
      </div>

<div class="analytics-card" (click)="setActiveFilterContext('live'); toggleTable('fortuneLiveStats')" *ngIf="hasFortuneLiveStatsCard">
  <div class="card-body">
    <div class="metric-icon">
      <i class="fas fa-bolt"></i>
    </div>

    <h6 class="metric-label">Field Live Cash In / Day</h6>
    <h2 class="metric-value">${{ fortuneLiveCashInPerDay.toFixed(2) }}</h2>

    <h6 class="metric-label mt-3">Field Live Net / Day</h6>
    <h2 class="metric-value">${{ fortuneLiveNetPerDay.toFixed(2) }}</h2>
  </div>

  <div class="trend-indicator positive">
    <i class="fas fa-chart-line"></i>
    <span>{{ showFortuneLiveStats ? 'Hide' : 'View Details' }} • {{ fortuneLiveRows }} live rows</span>
  </div>
  <span class="badge bg-info">
    <i class="fas fa-satellite-dish"></i>
    Field Konnect
  </span>
</div>

<div class="analytics-card" (click)="setActiveFilterContext('live'); toggleTable('fortuneLiveTestStats')" *ngIf="hasFortuneLiveTestStatsCard">
  <div class="card-body">
    <div class="metric-icon">
      <i class="fas fa-vial"></i>
    </div>

    <h6 class="metric-label">Warehouse Test Cash In / Day</h6>
    <h2 class="metric-value">${{ fortuneLiveTestCashInPerDay.toFixed(2) }}</h2>

    <h6 class="metric-label mt-3">Warehouse Test Net / Day</h6>
    <h2 class="metric-value">${{ fortuneLiveTestNetPerDay.toFixed(2) }}</h2>
  </div>

  <div class="trend-indicator positive">
    <i class="fas fa-chart-line"></i>
    <span>{{ showFortuneLiveTestStats ? 'Hide' : 'View Details' }} â€¢ {{ fortuneLiveTestRows }} test rows</span>
  </div>
  <span class="badge bg-secondary">
    <i class="fas fa-warehouse"></i>
    Test Konnect
  </span>
</div>

<div
  class="card analytics-card d-flex justify-content-center align-items-center text-center"
  (click)="setActiveFilterContext('regular'); toggleTable('topGameStats')"
  *ngIf="hasTopGameCard"
>
  <div class="card-body">
    <h6 class="card-title text-uppercase text-muted mb-2">
      Top Game (Avg Coin/Day/Board)
    </h6>

    <h2 class="fw-bold mb-1">{{ topGamePerDay.gameName }}</h2>

    <span class="badge bg-warning text-dark px-3 py-2 d-inline-flex align-items-center">
      <i class="fas fa-crown me-2"></i>
      {{ topGamePerDay.avg | number:'1.0-2' }}
    </span>

    <small class="text-muted mt-2">{{ filteredGameCount }} filtered games</small>
  </div>
</div>
<!-- Sales Outlet Sales Card -->
    <div class="analytics-card" (click)="toggleTable('salesOutlet')" *ngIf="showDashBoardCard.salesOutlet && salesOutletBoardsCount > 0">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-store"></i>
        </div>
        <h6 class="metric-label">Board Sales</h6>
        <h2 class="metric-value">{{ salesOutletBoardsCount }}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-dollar-sign"></i>
          <span>{{ salesOutletTotalValue | currency:'USD' }}</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-tags"></i>
          Boards @ ${{ salesOutletBoardPrice }}
        </span>
      </div>
    </div>













    <div class="analytics-card" (click)="toggleTable('revenue')" *ngIf="showDashBoardCard.monthlyRevenue && currentUserType !== 'EXTERNAL'">
      
      <div class="card-body">
        <div class="notification-icon" (click)="markPaymentsAsSeen()">
          <div class="metric-icon">
            <i class="fas fa-money-bill-wave"></i>
            <span *ngIf="unseenPaymentsCount > 0" class="badge">{{ unseenPaymentsCount }}</span>
          </div>
        </div>
        <h6 class="metric-label">Monthly Revenue</h6>
        <h2 class="metric-value" *ngIf="salesReps">  {{ getTotalMonthlyPayment() | currency:'USD' }}</h2>
        <span>Collected:</span>
        <span class="sub-metric" *ngIf="!isLoading">
         {{ getTotalAmountPaid() | currency:'USD' }}
        </span>

        <span>Owes Us:</span>
        <span class="sub-metric text-danger" *ngIf="!isLoading">
         {{ getTotalAmountOwed() | currency:'USD' }}
        </span>

   
        
        <div class="trend-indicator positive">
          <i class="fas fa-arrow-up"></i>
          <span>Expected</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-calendar"></i>
          Monthly
        </span>
      </div>
    </div>

    <div class="analytics-card" (click)="toggleTable('pickupLocationStats')" *ngIf="currentUserType !== 'EXTERNAL'">
      <div class="card-body">
        <div class="metric-icon"><i class="fas fa-truck-loading"></i></div>
        <h6 class="metric-label">Locations to Pick Up</h6>
        <h2 class="metric-value">{{ pickupContractLocations.length }}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-map-marker-alt"></i>
          <span>{{ showPickupLocationStats ? 'Hide' : 'View Locations' }}</span>
        </div>
        <span class="badge bg-warning text-dark">Pickup List</span>
      </div>
    </div>

  </div>

  <div class="section-heading mt-2">
    <div>
      <h5>Operations Overview</h5>
      <p>Inventory, contracts, leads, and supporting analytics.</p>
    </div>
  </div>

  <div class="analytics-cards secondary-grid">
    <!-- Game Stats Card -->
    <div class="analytics-card" (click)="setActiveFilterContext('regular'); toggleTable('gameStats')" *ngIf="hasGameStatsCard">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-gamepad"></i>
        </div>
        <h6 class="metric-label">Game Statistics</h6>
        <h2 class="metric-value">{{ filteredGameCount }}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-info-circle"></i>
          <span>{{ filteredRegularBoardCount }} visible boards</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-chart-bar"></i>
          {{showGameStats ? 'Hide' : 'Show'}} Stats
        </span>
      </div>
    </div>
        <!-- Total Machine Count Card -->
    <div class="analytics-card" (click)="toggleTable('location')" *ngIf="showDashBoardCard.totalMachieCount">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-microchip"></i>
        </div>
        <h6 class="metric-label">Total Machine Count</h6>
        <h2 class="metric-value">{{displayedContractedBoardsCount}}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-check-circle"></i>
          <span>Active</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-cog"></i>
          Contracted
        </span>
      </div>
    </div>

    <!-- Machine Available To Deploy Card -->

    <!-- Board Inventory Card -->
    <div class="analytics-card" (click)="toggleTable('boardInventory')" *ngIf="showDashBoardCard.boardInventory">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-clipboard-list"></i>
        </div>
        <h6 class="metric-label">Board Inventory</h6>
        <h2 class="metric-value">{{ displayedBoardInventoryTotalBoards }}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-map-marker-alt"></i>
          <span>{{ displayedBoardInventoryLocations.length }} Locations</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-boxes"></i>
          Available Boards
        </span>
      </div>
    </div>

    <div class="analytics-card" (click)="toggleTable('warehouse')" *ngIf="showDashBoardCard.machineAvaiableDeploy">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-box-open"></i>
        </div>
        <h6 class="metric-label">Machines Available</h6>
        <h2 class="metric-value">{{displayedWarehouseBoardsCount}}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-warehouse"></i>
          <span>In Stock</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-truck-loading"></i>
          Warehouse
        </span>
      </div>
    </div>

    <!-- Last Week's Installation Card -->
    <div class="analytics-card" (click)="toggleTable('newLocation')" *ngIf="showDashBoardCard.lastWeekInstallation">
      <div class="card-body">
        <div class="metric-icon">
          <i class="fas fa-tools"></i>
        </div>
        <h6 class="metric-label">Last Week's Installation</h6>
        <div class="d-flex flex-column">
          <div class="metric-value">{{displayedTotalNewLocations}}</div>
          <small class="text-muted">New Contracts</small>
          <div class="metric-value mt-2">{{displayedTotalNewBoards}}</div>
          <small class="text-muted">Machines Installed</small>
        </div>
        <span class="badge bg-success mt-2">
          <i class="fas fa-flag-checkered"></i>
          50 Machine Target
        </span>
      </div>
    </div>
    <!-- Leads Card -->
    <div class="analytics-card" (click)="toggleTable('leads')" *ngIf="showDashBoardCard.totalLeads">
      <div class="card-body position-relative">
        <!-- Small spinner on top right corner when loading -->
        <div *ngIf="isLoading" class="position-absolute top-0 end-0 m-2">
          <div class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div class="metric-icon">
          <i class="fas fa-user-plus"></i>
        </div>
        <h6 class="metric-label">Total Leads</h6>
        <h2 class="metric-value">{{ displayedTotalLeads }}</h2>
        <div class="trend-indicator positive">
          <i class="fas fa-eye"></i>
          <span>Click to View</span>
        </div>
        <span class="badge bg-success">
          <i class="fas fa-users"></i>
          Leads
        </span>
    </div>
  </div>
  <!-- RPT/Games chart trigger card -->
<div
  class="card analytics-card d-flex justify-content-center align-items-center text-center"
  (click)="toggleTable('rptChart')"
  *ngIf="currentUserType !== 'EXTERNAL'">
  <div class="card-body">
    <h6 class="card-title text-uppercase text-muted mb-2">
      RPT vs Games
    </h6>
    <h2 class="fw-bold mb-1">
      {{ showRptChart ? 'Hide' : 'Show' }} Chart
    </h2>
    <span class="badge bg-info text-dark px-3 py-2 d-inline-flex align-items-center">
      <i class="fas fa-wave-square me-2"></i>
      Per Board Lines
    </span>
  </div>
</div>
<!-- Top Games chart trigger card -->
<div
  class="card analytics-card d-flex justify-content-center align-items-center text-center"
  (click)="toggleTable('topGamesChart')"
  *ngIf="currentUserType !== 'EXTERNAL'">
  <div class="card-body">
    <h6 class="card-title text-uppercase text-muted mb-2">
      Top Games RPT
    </h6>
    <h2 class="fw-bold mb-1">
      {{ showTopGamesChart ? 'Hide' : 'Show' }} Chart
    </h2>
    <span class="badge bg-warning text-dark px-3 py-2 d-inline-flex align-items-center">
      <i class="fas fa-gamepad me-2"></i>
      Per Game Lines
    </span>
  </div>
</div>

    
  </div>

  <!-- Date Range Filter - Moved above tables -->
<div class="row filter-toolbar g-3 align-items-end mb-4"
     *ngIf="showStats || showFortuneLiveStats || showFortuneLiveTestStats || showFusionLeaseStats || showBoardSalesStats">
  <!-- Dates -->
  <div class="col-md-3">
    <div class="date-picker-container">
      <div class="form-group">
        <label for="startDate">Start Date</label>
        <input type="text"
               id="startDate"
               class="form-control"
               placeholder="yyyy-mm-dd"
               ngbDatepicker
               #startDatePicker="ngbDatepicker"
               [placement]="'top'"
               [(ngModel)]="statsStartDate"
               (dateSelect)="onDateChange()"
               (click)="startDatePicker.toggle()">
      </div>
      <div class="form-group">
        <label for="endDate">End Date</label>
        <input type="text"
               id="endDate"
               class="form-control"
               placeholder="yyyy-mm-dd"
               ngbDatepicker
               #endDatePicker="ngbDatepicker"
               [placement]="'top'"
               [(ngModel)]="statsEndDate"
               (dateSelect)="onDateChange()"
               (click)="endDatePicker.toggle()">
      </div>
    </div>
  </div>

  <!-- Sales Rep -->
  <div class="col-md-3" *ngIf="!isExternalSalesRep(); else lockedSalesRepView">
    <div class="form-group">
      <label for="salesRepFilter">Sales Rep</label>
      <select 
        id="salesRepFilter" 
        class="form-control"
        [(ngModel)]="activeSelectedSalesRep"
        (ngModelChange)="onSalesRepFilterChange()">
        <option [ngValue]="null">All</option>
        <option *ngFor="let sr of filteredSalesRepsArray" [ngValue]="sr">
          {{sr.firstName || 'N/A'}} {{sr.lastName || 'N/A'}}
        </option>
      </select>
    </div>
  </div>

  <ng-template #lockedSalesRepView>
    <div class="col-md-3">
      <div class="form-group">
        <label>Sales Rep</label>
        <input
          class="form-control"
          [value]="(currentSalesRep?.firstName || '') + ' ' + (currentSalesRep?.lastName || '')"
          readonly
        />
      </div>
    </div>
  </ng-template>

  <!-- State -->
  <div class="col-md-2">
    <div class="form-group">
      <label for="stateFilter">State</label>
      <select
        id="stateFilter"
        class="form-control"
        [(ngModel)]="activeSelectedState"
        (ngModelChange)="onStateFilterChange()">
        <option [ngValue]="null">All</option>
        <option *ngFor="let st of states" [ngValue]="st">{{ st }}</option>
      </select>
    </div>
  </div>

  <!-- Search -->
  <div class="col-md-2">
    <div class="form-group">
      <label for="searchFilter">Search</label>
      <input
        type="text"
        id="searchFilter"
        class="form-control"
        [(ngModel)]="activeSearchTerm"
        (ngModelChange)="onSearchDebounced($event)"
        placeholder="Search by game, sales rep, or location...">
    </div>
  </div>

  <!-- Board/Serial Search -->
  <div class="col-md-2">
    <div class="form-group">
      <label for="boardSearchFilter">Board / Serial</label>
      <input
        type="text"
        id="boardSearchFilter"
        class="form-control"
        [(ngModel)]="activeBoardSearchTerm"
        (ngModelChange)="onBoardSearchDebounced($event)"
        placeholder="Search by asset tag or serial...">
    </div>
  </div>
</div>

<!-- Dedicated Board Stats tables: positioned below the complete filter/search toolbar. -->
<app-sales-rep-game-stats
  *ngIf="showFusionLeaseStats"
  title="Fusion Lease Board Stats"
  groupBy="salesRep"
  tableFormat="boardStats"
  currentCategory="FUSION_LEASE"
  [allowedNames]="fusionLeaseSalesReps"
  [boardStats]="fusionLeaseValidStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<app-sales-rep-game-stats
  *ngIf="showFusionLeaseStats && fusionLeaseFlaggedStats.length > 0"
  title="Flagged Fusion Lease Board Stats"
  [flagged]="true"
  groupBy="salesRep"
  tableFormat="boardStats"
  currentCategory="FUSION_LEASE"
  [allowedNames]="fusionLeaseSalesReps"
  [boardStats]="fusionLeaseFlaggedStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<div class="card analytics-card table-card mt-4" *ngIf="showPickupLocationStats">
  <div class="card-body">
    <h4 class="card-title mb-4">Locations to Pick Up</h4>
    <div class="table-responsive breakdown-table">
      <table class="table table-bordered table-hover">
        <thead>
          <tr class="table-warning totals-row">
            <th colspan="7"><strong>Total Locations ({{ pickupContractLocations.length }})</strong></th>
            <th>
              <strong>{{ pickupContractLocations | sum:'numBoards' }} Machines</strong>
            </th>
          </tr>
          <tr>
            <th>Location Name</th>
            <th>Sales Rep</th>
            <th>Address</th>
            <th>Address 2</th>
            <th>City</th>
            <th>State</th>
            <th>ZIP</th>
            <th>Number of Machines</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let loc of pickupContractLocations; trackBy: trackByLocation">
            <td>{{ loc.locationName }}</td>
            <td>{{ loc.salesRep?.firstName }} {{ loc.salesRep?.lastName }}</td>
            <td>{{ loc.businessAddress?.streetAddress1 || '-' }}</td>
            <td>{{ loc.businessAddress?.streetAddress2 || '-' }}</td>
            <td>{{ loc.businessAddress?.city || '-' }}</td>
            <td>{{ loc.businessAddress?.state || '-' }}</td>
            <td>{{ loc.businessAddress?.zipCode || '-' }}</td>
            <td>{{ loc.numBoards || 0 }}</td>
          </tr>
          <tr *ngIf="pickupContractLocations.length === 0">
            <td colspan="8" class="text-center text-muted py-4">No pickup locations found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-sales-rep-game-stats
  *ngIf="showPickupLocationStats"
  title="Pickup Board Stats"
  groupBy="location"
  tableFormat="boardStats"
  currentCategory="PICKUP"
  [allowedNames]="pickupLocations"
  [boardStats]="pickupLocationValidStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<app-sales-rep-game-stats
  *ngIf="showPickupLocationStats && pickupLocationFlaggedStats.length > 0"
  title="Flagged Pickup Board Stats"
  [flagged]="true"
  groupBy="location"
  tableFormat="boardStats"
  currentCategory="PICKUP"
  [allowedNames]="pickupLocations"
  [boardStats]="pickupLocationFlaggedStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<app-sales-rep-game-stats
  *ngIf="showBoardSalesStats"
  title="Board Sales Stats"
  groupBy="salesRep"
  tableFormat="boardStats"
  currentCategory="BOARD_SALES"
  [allowedNames]="[]"
  [boardStats]="boardSalesValidStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<app-sales-rep-game-stats
  *ngIf="showBoardSalesStats && boardSalesFlaggedStats.length > 0"
  title="Flagged Board Sales Stats"
  [flagged]="true"
  groupBy="salesRep"
  tableFormat="boardStats"
  currentCategory="BOARD_SALES"
  [allowedNames]="[]"
  [boardStats]="boardSalesFlaggedStats"
  [startDate]="startDate"
  [endDate]="endDate"
  [isRoot]="isRoot"
  (categoryChange)="moveStatToCategory($event.stat, $event.category)"
  (flagChange)="onDedicatedFlagChange($event)"
  (deleteStat)="deleteRow($event)">
</app-sales-rep-game-stats>

<!-- RPT vs Games chart (per-board) -->
<div class="row" *ngIf="showRptChart && rptGamesSeries.length">
  <div class="col-12">
    <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-2">Board RPT vs Cumulative Games</h4>
        <div class="text-muted small mb-3">
          Uses current filters. RPT = coinOut / coinIn (per read). Games are cumulative per board over time.
        </div>
        <apx-chart
          [series]="rptGamesSeries"
          [chart]="rptGamesChartOptions.chart"
          [stroke]="rptGamesChartOptions.stroke"
          [dataLabels]="rptGamesChartOptions.dataLabels"
          [markers]="rptGamesChartOptions.markers"
          [xaxis]="rptGamesChartOptions.xaxis"
          [yaxis]="rptGamesChartOptions.yaxis"
          [tooltip]="rptGamesChartOptions.tooltip"
          [legend]="rptGamesChartOptions.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

<!-- Top Games RPT chart -->
<div class="row" *ngIf="showTopGamesChart && rptTopGamesSeries.length">
  <div class="col-12">
    <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-2">Top Games RPT vs Cumulative Games</h4>
        <div class="text-muted small mb-3">
          Uses current filters. RPT = coinOut / coinIn per read; games are cumulative per game.
        </div>
        <apx-chart
          [series]="rptTopGamesSeries"
          [chart]="topGamesChartOptions.chart"
          [stroke]="topGamesChartOptions.stroke"
          [dataLabels]="topGamesChartOptions.dataLabels"
          [markers]="topGamesChartOptions.markers"
          [xaxis]="topGamesChartOptions.xaxis"
          [yaxis]="topGamesChartOptions.yaxis"
          [tooltip]="topGamesChartOptions.tooltip"
          [legend]="topGamesChartOptions.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div>

 <!-- Game Stats Section with Tabs -->
<div class="row" *ngIf="showGameStats">
  <div class="col-12">
    <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Game Statistics</h4>

        <!-- Bootstrap Tabs -->
        <ul class="nav nav-tabs mb-3" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" [ngClass]="{active: activeGameTab === 'byGame'}"
                    (click)="activeGameTab = 'byGame'">By Game</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [ngClass]="{active: activeGameTab === 'bySalesRep'}"
                    (click)="activeGameTab = 'bySalesRep'">By Sales Rep</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [ngClass]="{active: activeGameTab === 'byState'}"
                    (click)="activeGameTab = 'byState'">By State</button>
          </li>
        </ul>

        <!-- Tab 1: By Game -->
        <div *ngIf="activeGameTab === 'byGame'">
   <div class="table-responsive-sm overflow-auto d-block" style="max-width: 100vw;">
      <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Game Name</th>
                  <th>Count</th>
                  <th>Cash In</th>
                  <th>Cash Out</th>
                  <th>Net Revenue</th>
                  <th>Turnover</th>
                  <th>Credit Won</th>
                  <th>Games Played</th>
                  <th>Games Won</th>
                  <th>Payout %</th>
                  <th>Days Since Last</th>
                  <th>Cash In/Day</th>
                  <th>Net/Day</th>
                  <th>RPT</th>
                  <th>Bet Multiplier</th>
                  <th>Bet/Play</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let gameKey of gameList; trackBy: trackByGameKey">
                  <td><strong>{{gameKey}}</strong></td>
                  <td>{{(boardStatsByGame.get(gameKey)?.count || 0).toFixed(0)}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.totalCashin || 0) | number:'1.0-0'}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.totalCashout || 0) | number:'1.0-0'}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.totalNet || 0) | number:'1.0-0'}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.totalCoinIn || 0) | number:'1.0-0'}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.totalCoinOut || 0) | number:'1.0-0'}}</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.totalGamesPlayed || 0) | number:'1.0-0'}}</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.totalGamesWon || 0) | number:'1.0-0'}}</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.payoutRatio * 100 || 0) | number:'1.0-0'}}%</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.avgDays || 0) | number:'1.0-0'}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.avgDailyCashIn || 0).toFixed(0)}}</td>
                  <td>${{(boardStatsByGame.get(gameKey)?.avgDailyNet || 0) | number:'1.0-0'}}</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.rpt * 100 || 0) | number:'1.0-0'}}%</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.betMultiplier || 0) | number:'1.0-2'}}</td>
                  <td>{{(boardStatsByGame.get(gameKey)?.betPerPlay || 0) | number:'1.0-2'}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-info">
                  <td><strong>Totals</strong></td>
                  <td><strong>{{getTotalCount()}}</strong></td>
                  <td><strong>${{getTotalValue('totalCashin') | number:'1.0-0'}}</strong></td>
                  <td><strong>${{getTotalValue('totalCashout') | number:'1.0-0'}}</strong></td>
                  <td><strong>${{getTotalValue('totalNet') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{getTotalValue('totalCoinIn') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{getTotalValue('totalCoinOut') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{getTotalValue('totalGamesPlayed') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{getTotalValue('totalGamesWon') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{(getTotalValue('totalCashout') / getTotalValue('totalCashin') * 100) | number:'1.0-0'}}%</strong></td>
                  <td><strong>{{getAverageValue('avgDays') | number:'1.0-0'}}</strong></td>
                  <td><strong>${{getAverageValue('avgDailyCashIn') | number:'1.0-0'}}</strong></td>
                  <td><strong>${{getAverageValue('avgDailyNet') | number:'1.0-0'}}</strong></td>
                  <td><strong>{{(getTotalValue('totalCoinOut') / getTotalValue('totalCoinIn') * 100) | number:'1.0-0'}}%</strong></td>
                  <td><strong>{{(getTotalValue('totalCoinIn') / getTotalValue('totalCashin')) | number:'1.0-2'}}</strong></td>
                  <td><strong>{{(getTotalValue('totalCoinIn') / getTotalValue('totalGamesPlayed')) | number:'1.0-2'}}</strong></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <!-- Tab 2: By Sales Rep -->
<div *ngIf="activeGameTab === 'bySalesRep'">
  <app-sales-rep-game-stats
    [boardStats]="validStats"
    [startDate]="startDate"
    [endDate]="endDate"
  ></app-sales-rep-game-stats>
</div>



        <!-- Tab 3: By State -->
      <div *ngIf="activeGameTab === 'byState'">
        <app-state-game-stats
          [boardStats]="validStats"
          [startDate]="startDate"
          [endDate]="endDate">
        </app-state-game-stats>
      </div>

        </div>
      </div>
    </div>
  </div>
</div>


<!-- Fortune Live Stats Section -->
<div class="row" *ngIf="showFortuneLiveStats">
  <div class="col-12">
    <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Fortune Konnect Field Live Analysis</h4>

        <div class="table-responsive breakdown-table">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">
            <thead>
              <tr class="table-info totals-row">
                <th colspan="7"><strong>Totals ({{filteredFortuneLiveStats.length}} Rows)</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'cashOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>1.0</strong></th>
                <th><strong>{{filteredFortuneLiveStats | average:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | average:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>{{((filteredFortuneLiveStats | sum:'cashOut') / (filteredFortuneLiveStats | sum:'cashIn') * 100) | number:'1.0-2'}}%</strong></th>
                <th><strong>{{((filteredFortuneLiveStats | sum:'coinOut') / (filteredFortuneLiveStats | sum:'coinIn') * 100) | number:'1.0-0'}}%</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'coinIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'coinOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'gamesPlayed' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveStats | sum:'gamesWon' | number:'1.0-0'}}</strong></th>
                <th><strong>{{(filteredFortuneLiveStats | sum:'coinIn') / (filteredFortuneLiveStats | sum:'cashIn') | number:'1.0-2'}}</strong></th>
                <th><strong>{{(filteredFortuneLiveStats | sum:'coinIn') / (filteredFortuneLiveStats | sum:'gamesPlayed') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot"></th>
              </tr>
              <tr>
                <th>Read Timestamp</th>
                <th>Asset Tag</th>
                <th>Serial Number</th>
                <th>Location</th>
                <th>Sales Rep</th>
                <th>State</th>
                <th>Game Name</th>
                <th>Cash In</th>
                <th>Cash Out</th>
                <th>Net Revenue</th>
                <th>Days Since Last</th>
                <th>Cash In/Day</th>
                <th>Net/Day</th>
                <th>Payout %</th>
                <th>RPT</th>
                <th>Turnover</th>
                <th>Credit Won</th>
                <th>Games Played</th>
                <th>Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredFortuneLiveStats">
                <td>{{ item.statDate }}</td>
                <td>{{ item.assetTag || '—' }}</td>
                <td>{{ item.serialNumber || '—' }}</td>
                <td>{{ item.locationName || '—' }}</td>
                <td>{{ item.salesRepName || '—' }}</td>
                <td>{{ getFortuneState(item) }}</td>
                <td>
                  <div>{{ getFortuneGameName(item) }}</div>
                  <button class="btn btn-sm btn-link text-primary p-0 mt-1"
                          (click)="openLiveBoardGameStatsModal(item, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>
                  <div *ngIf="isFlaggedFortuneLiveStat(item)" class="text-danger small mt-1">
                    🚩 {{ getFortuneLiveFlagNote(item) }}
                  </div>
                </td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ item.cashOut | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>1.0</td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>{{ getFortunePayout(item) | number:'1.0-2' }}%</td>
                <td>{{ getFortuneRpt(item) | number:'1.0-0' }}%</td>
                <td>{{ item.coinIn | number:'1.0-2' }}</td>
                <td>{{ item.coinOut | number:'1.0-2' }}</td>
                <td>{{ item.gamesPlayed | number:'1.0-0' }}</td>
                <td>{{ item.gamesWon | number:'1.0-0' }}</td>
                <td>{{ getFortuneBetMultiplier(item) | number:'1.0-2' }}</td>
                <td>{{ getFortuneBetPerPlay(item) | number:'1.0-2' }}</td>
                <td *ngIf="isRoot" class="text-end">
                  <button
                    *ngIf="!isFlaggedFortuneLiveStat(item)"
                    class="btn btn-sm btn-outline-warning me-1"
                    (click)="flagFortuneLiveStat(item)">
                    🚩 Flag
                  </button>
                  <button
                    *ngIf="isFlaggedFortuneLiveStat(item)"
                    class="btn btn-sm btn-outline-success me-1"
                    (click)="unflagFortuneLiveStat(item)">
                    ✅ Unflag
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteFortuneLiveRow(item)">
                    Delete
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredFortuneLiveStats.length === 0">
                <td [attr.colspan]="isRoot ? 22 : 21" class="text-center text-muted py-4">No Fortune Konnect field live rows found for the current filters.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fortune Live Warehouse Test Stats Section -->
<div class="row" *ngIf="showFortuneLiveTestStats">
  <div class="col-12">
    <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Fortune Konnect Warehouse Test Analysis</h4>

        <div class="table-responsive breakdown-table">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">
            <thead>
              <tr class="table-info totals-row">
                <th colspan="7"><strong>Totals ({{filteredFortuneLiveTestStats.length}} Rows)</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'cashOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>1.0</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | average:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | average:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>{{((filteredFortuneLiveTestStats | sum:'cashOut') / (filteredFortuneLiveTestStats | sum:'cashIn') * 100) | number:'1.0-2'}}%</strong></th>
                <th><strong>{{((filteredFortuneLiveTestStats | sum:'coinOut') / (filteredFortuneLiveTestStats | sum:'coinIn') * 100) | number:'1.0-0'}}%</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'coinIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'coinOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'gamesPlayed' | number:'1.0-0'}}</strong></th>
                <th><strong>{{filteredFortuneLiveTestStats | sum:'gamesWon' | number:'1.0-0'}}</strong></th>
                <th><strong>{{(filteredFortuneLiveTestStats | sum:'coinIn') / (filteredFortuneLiveTestStats | sum:'cashIn') | number:'1.0-2'}}</strong></th>
                <th><strong>{{(filteredFortuneLiveTestStats | sum:'coinIn') / (filteredFortuneLiveTestStats | sum:'gamesPlayed') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot"></th>
              </tr>
              <tr>
                <th>Read Timestamp</th>
                <th>Asset Tag</th>
                <th>Serial Number</th>
                <th>Location</th>
                <th>Sales Rep</th>
                <th>State</th>
                <th>Game Name</th>
                <th>Cash In</th>
                <th>Cash Out</th>
                <th>Net Revenue</th>
                <th>Days Since Last</th>
                <th>Cash In/Day</th>
                <th>Net/Day</th>
                <th>Payout %</th>
                <th>RPT</th>
                <th>Turnover</th>
                <th>Credit Won</th>
                <th>Games Played</th>
                <th>Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredFortuneLiveTestStats">
                <td>{{ item.statDate }}</td>
                <td>{{ item.assetTag || 'â€”' }}</td>
                <td>{{ item.serialNumber || 'â€”' }}</td>
                <td>{{ item.locationName || 'â€”' }}</td>
                <td>{{ item.salesRepName || 'â€”' }}</td>
                <td>{{ getFortuneState(item) }}</td>
                <td>
                  <div>{{ getFortuneGameName(item) }}</div>
                  <button class="btn btn-sm btn-link text-primary p-0 mt-1"
                          (click)="openLiveBoardGameStatsModal(item, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>
                  <div *ngIf="isFlaggedFortuneLiveStat(item)" class="text-danger small mt-1">
                    🚩 {{ getFortuneLiveFlagNote(item) }}
                  </div>
                </td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ item.cashOut | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>1.0</td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>{{ getFortunePayout(item) | number:'1.0-2' }}%</td>
                <td>{{ getFortuneRpt(item) | number:'1.0-0' }}%</td>
                <td>{{ item.coinIn | number:'1.0-2' }}</td>
                <td>{{ item.coinOut | number:'1.0-2' }}</td>
                <td>{{ item.gamesPlayed | number:'1.0-0' }}</td>
                <td>{{ item.gamesWon | number:'1.0-0' }}</td>
                <td>{{ getFortuneBetMultiplier(item) | number:'1.0-2' }}</td>
                <td>{{ getFortuneBetPerPlay(item) | number:'1.0-2' }}</td>
                <td *ngIf="isRoot" class="text-end">
                  <button
                    *ngIf="!isFlaggedFortuneLiveStat(item)"
                    class="btn btn-sm btn-outline-warning me-1"
                    (click)="flagFortuneLiveStat(item)">
                    🚩 Flag
                  </button>
                  <button
                    *ngIf="isFlaggedFortuneLiveStat(item)"
                    class="btn btn-sm btn-outline-success me-1"
                    (click)="unflagFortuneLiveStat(item)">
                    ✅ Unflag
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteFortuneLiveRow(item)">
                    Delete
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredFortuneLiveTestStats.length === 0">
                <td [attr.colspan]="isRoot ? 22 : 21" class="text-center text-muted py-4">No Fortune Konnect warehouse test rows found for the current filters.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Flagged Fortune Live Stats Section -->
<div class="row" *ngIf="showFortuneLiveStats && flaggedFortuneLiveStats.length > 0">
  <div class="col-12">
    <div class="card analytics-card table-card flagged-stats-card">
      <div class="card-body">
        <h4 class="card-title mb-2">Flagged Fortune Konnect Field Live Rows</h4>
        <div class="text-muted small mb-3">
          These rows are excluded from Fortune Konnect Field Live Analysis totals and averages.
        </div>

        <div class="table-responsive breakdown-table">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">
            <thead>
              <tr class="table-warning totals-row">
                <th colspan="7"><strong>Flagged Totals ({{flaggedFortuneLiveStats.length}} Rows)</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'cashOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>1.0</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | average:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | average:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>{{((flaggedFortuneLiveStats | sum:'cashOut') / (flaggedFortuneLiveStats | sum:'cashIn') * 100) | number:'1.0-2'}}%</strong></th>
                <th><strong>{{((flaggedFortuneLiveStats | sum:'coinOut') / (flaggedFortuneLiveStats | sum:'coinIn') * 100) | number:'1.0-0'}}%</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'coinIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'coinOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'gamesPlayed' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveStats | sum:'gamesWon' | number:'1.0-0'}}</strong></th>
                <th><strong>{{(flaggedFortuneLiveStats | sum:'coinIn') / (flaggedFortuneLiveStats | sum:'cashIn') | number:'1.0-2'}}</strong></th>
                <th><strong>{{(flaggedFortuneLiveStats | sum:'coinIn') / (flaggedFortuneLiveStats | sum:'gamesPlayed') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot"></th>
              </tr>
              <tr>
                <th>Read Timestamp</th>
                <th>Asset Tag</th>
                <th>Serial Number</th>
                <th>Location</th>
                <th>Sales Rep</th>
                <th>State</th>
                <th>Game Name</th>
                <th>Cash In</th>
                <th>Cash Out</th>
                <th>Net Revenue</th>
                <th>Days Since Last</th>
                <th>Cash In/Day</th>
                <th>Net/Day</th>
                <th>Payout %</th>
                <th>RPT</th>
                <th>Turnover</th>
                <th>Credit Won</th>
                <th>Games Played</th>
                <th>Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of flaggedFortuneLiveStats" class="table-warning">
                <td>{{ item.statDate }}</td>
                <td>{{ item.assetTag || '—' }}</td>
                <td>{{ item.serialNumber || '—' }}</td>
                <td>{{ item.locationName || '—' }}</td>
                <td>{{ item.salesRepName || '—' }}</td>
                <td>{{ getFortuneState(item) }}</td>
                <td>
                  <div>{{ getFortuneGameName(item) }}</div>
                  <button class="btn btn-sm btn-link text-primary p-0 mt-1"
                          (click)="openLiveBoardGameStatsModal(item, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>
                  <div class="text-danger small mt-1">
                    🚩 {{ getFortuneLiveFlagNote(item) }}
                  </div>
                </td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ item.cashOut | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>1.0</td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>{{ getFortunePayout(item) | number:'1.0-2' }}%</td>
                <td>{{ getFortuneRpt(item) | number:'1.0-0' }}%</td>
                <td>{{ item.coinIn | number:'1.0-2' }}</td>
                <td>{{ item.coinOut | number:'1.0-2' }}</td>
                <td>{{ item.gamesPlayed | number:'1.0-0' }}</td>
                <td>{{ item.gamesWon | number:'1.0-0' }}</td>
                <td>{{ getFortuneBetMultiplier(item) | number:'1.0-2' }}</td>
                <td>{{ getFortuneBetPerPlay(item) | number:'1.0-2' }}</td>
                <td *ngIf="isRoot" class="text-end">
                  <button
                    class="btn btn-sm btn-outline-success me-1"
                    (click)="unflagFortuneLiveStat(item)">
                    Unflag
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteFortuneLiveRow(item)">
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Flagged Fortune Live Warehouse Test Section -->
<div class="row" *ngIf="showFortuneLiveTestStats && flaggedFortuneLiveTestStats.length > 0">
  <div class="col-12">
    <div class="card analytics-card table-card flagged-stats-card">
      <div class="card-body">
        <h4 class="card-title mb-2">Flagged Fortune Konnect Warehouse Test Rows</h4>
        <div class="text-muted small mb-3">
          These rows are excluded from Fortune Konnect Warehouse Test Analysis totals and averages.
        </div>

        <div class="table-responsive breakdown-table">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">
            <thead>
              <tr class="table-warning totals-row">
                <th colspan="7"><strong>Flagged Totals ({{flaggedFortuneLiveTestStats.length}} Rows)</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'cashOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>1.0</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | average:'cashIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | average:'net' | number:'1.0-0'}}</strong></th>
                <th><strong>{{((flaggedFortuneLiveTestStats | sum:'cashOut') / (flaggedFortuneLiveTestStats | sum:'cashIn') * 100) | number:'1.0-2'}}%</strong></th>
                <th><strong>{{((flaggedFortuneLiveTestStats | sum:'coinOut') / (flaggedFortuneLiveTestStats | sum:'coinIn') * 100) | number:'1.0-0'}}%</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'coinIn' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'coinOut' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'gamesPlayed' | number:'1.0-0'}}</strong></th>
                <th><strong>{{flaggedFortuneLiveTestStats | sum:'gamesWon' | number:'1.0-0'}}</strong></th>
                <th><strong>{{(flaggedFortuneLiveTestStats | sum:'coinIn') / (flaggedFortuneLiveTestStats | sum:'cashIn') | number:'1.0-2'}}</strong></th>
                <th><strong>{{(flaggedFortuneLiveTestStats | sum:'coinIn') / (flaggedFortuneLiveTestStats | sum:'gamesPlayed') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot"></th>
              </tr>
              <tr>
                <th>Read Timestamp</th>
                <th>Asset Tag</th>
                <th>Serial Number</th>
                <th>Location</th>
                <th>Sales Rep</th>
                <th>State</th>
                <th>Game Name</th>
                <th>Cash In</th>
                <th>Cash Out</th>
                <th>Net Revenue</th>
                <th>Days Since Last</th>
                <th>Cash In/Day</th>
                <th>Net/Day</th>
                <th>Payout %</th>
                <th>RPT</th>
                <th>Turnover</th>
                <th>Credit Won</th>
                <th>Games Played</th>
                <th>Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of flaggedFortuneLiveTestStats" class="table-warning">
                <td>{{ item.statDate }}</td>
                <td>{{ item.assetTag || '—' }}</td>
                <td>{{ item.serialNumber || '—' }}</td>
                <td>{{ item.locationName || '—' }}</td>
                <td>{{ item.salesRepName || '—' }}</td>
                <td>{{ getFortuneState(item) }}</td>
                <td>
                  <div>{{ getFortuneGameName(item) }}</div>
                  <button class="btn btn-sm btn-link text-primary p-0 mt-1"
                          (click)="openLiveBoardGameStatsModal(item, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>
                  <div class="text-danger small mt-1">
                    🚩 {{ getFortuneLiveFlagNote(item) }}
                  </div>
                </td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ item.cashOut | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>1.0</td>
                <td>{{ item.cashIn | number:'1.0-2' }}</td>
                <td>{{ (item.net ?? ((item.cashIn || 0) - (item.cashOut || 0))) | number:'1.0-2' }}</td>
                <td>{{ getFortunePayout(item) | number:'1.0-2' }}%</td>
                <td>{{ getFortuneRpt(item) | number:'1.0-0' }}%</td>
                <td>{{ item.coinIn | number:'1.0-2' }}</td>
                <td>{{ item.coinOut | number:'1.0-2' }}</td>
                <td>{{ item.gamesPlayed | number:'1.0-0' }}</td>
                <td>{{ item.gamesWon | number:'1.0-0' }}</td>
                <td>{{ getFortuneBetMultiplier(item) | number:'1.0-2' }}</td>
                <td>{{ getFortuneBetPerPlay(item) | number:'1.0-2' }}</td>
                <td *ngIf="isRoot" class="text-end">
                  <button
                    class="btn btn-sm btn-outline-success me-1"
                    (click)="unflagFortuneLiveStat(item)">
                    Unflag
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteFortuneLiveRow(item)">
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
  
<!-- Board Stats Section -->
<div class="row" *ngIf="showStats">
  <div class="col-12">
      <div class="card analytics-card table-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Board Stats Analysis</h4>

        <div *ngIf="boardStatsLoading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div class="table-responsive breakdown-table" *ngIf="!boardStatsLoading">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">

            <thead>
              <!-- G Totals row FIRST, inside thead, with sticky th cells -->
              <tr class="table-info totals-row">
                <th class="sticky" colspan="6">
                  <strong>Totals ({{validStats.length}} Boards)</strong>
                </th>
                <th></th>

                <th class="sticky"><strong>{{validStats | sum:'cashInDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'cashOutDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'profit' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{daysSincePrevDisplay | number:'1.0-1'}}</strong></th>
                <th class="sticky"><strong>{{(validStats | average:'cashInDiff/daysSincePrevRead') | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(validStats | average:'profit/daysSincePrevRead') | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(validStats | average:'holdPercentage') * 100 | number:'1.0-2'}}%</strong></th>
                <th class="sticky"><strong>{{((validStats | sum:'coinOutDiff') / (validStats | sum:'coinInDiff')) * 100 | number:'1.0-0'}}%</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'coinInDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'coinOutDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'gamePlayedDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{validStats | sum:'gameWonDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(validStats | sum:'coinInDiff') / (validStats | sum:'cashInDiff') | number:'1.0-2'}}</strong></th>
                <th class="sticky"><strong>{{(validStats | sum:'coinInDiff') / (validStats | sum:'gamePlayedDiff') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot" class="sticky"></th>

                
                
              </tr>

              <!-- Column headers -->
              <tr>
                <th (click)="sortData('timeStamp')">Read Timestamp</th>
                <th (click)="sortData('assetTag')">Asset Tag</th>
                <th (click)="sortData('serialNumber')">Serial Number</th>
                <th (click)="sortData('location')">Location</th>
                <th (click)="sortData('salesRep')">Sales Rep</th>
                 <th (click)="sortData('salesRep')">State</th>
                <th (click)="sortData('gameName')">Game Name</th>
                <th (click)="sortData('cashIn')">Cash In</th>
                <th (click)="sortData('cashOut')">Cash Out</th>
                <th (click)="sortData('netRevenue')">Net Revenue</th>
                <th (click)="sortData('daysSincePrevRead')">Days Since Last</th>
                <th (click)="sortData('cashIn/day')">Cash In/Day</th>
                <th (click)="sortData('netRevenue/day')">Net/Day</th>
                <th (click)="sortData('payoutPercentage')">Payout %</th>
                <th (click)="sortData('rtp')">RPT</th>
                <th (click)="sortData('coinIn')">Turnover</th>
                <th (click)="sortData('coinOut')">Credit Won</th>
                <th (click)="sortData('gamesPlayed')">Games Played</th>
                <th (click)="sortData('gamesWon')">Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>

              </tr>
            </thead>

            <tbody>
              <!-- =+ Data rows only -->
              <tr 
                *ngFor="let item of validStats; trackBy: trackByStat"
        >
                <td>{{item.timeStamp | date}}</td>
                <td>
                  <a href="javascript:void(0);" (click)="openBoardStatsModal(item.board?.assetTag)">
                    {{item.board?.assetTag}}
                  </a>
                </td>
                <td>{{item.board?.serialNumber}}</td>
                <td>{{item.__locationName}}</td>
                <td>{{item.__salesRepName}}</td>
                <td>{{item.__state}}</td>
                <td>
                  {{ item.board?.currentDeployment?.installedGamePackage?.name }}

                  <button class="btn btn-sm btn-link text-primary ms-2"
                          (click)="openBoardGameStatsModal(item.id, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>

                  <!-- 🚩 FLAG NOTE -->
                  <div *ngIf="isFlaggedStat(item)" class="text-danger small">
                    🚩 {{ item.flaggedNote }}
                  </div>
                </td>
                <td>{{item.cashInDiff.toFixed(0)}}</td>
                <td>{{item.cashOutDiff.toFixed(0)}}</td>
                <td>{{item.profit?.toFixed(0)}}</td>
                <td>{{item.daysSincePrevRead}}</td>
                <td>{{(item.cashInDiff / item.daysSincePrevRead).toFixed(0)}}</td>
                <td>{{(item.profit / item.daysSincePrevRead).toFixed(0)}}</td>
                <td>{{(item.holdPercentage * 100) | number:'1.0-2'}}%</td>
                <td>{{(item.coinOutDiff / item.coinInDiff) * 100 | number:'1.0-0'}}%</td>
                <td>{{item.coinInDiff.toFixed(0)}}</td>
                <td>{{item.coinOutDiff.toFixed(0)}}</td>
                <td>{{item.gamePlayedDiff.toFixed(0)}}</td>
                <td>{{item.gameWonDiff.toFixed(0)}}</td>
                <td>{{(item.coinInDiff / item.cashInDiff).toFixed(2)}}</td>
                <td>{{(item.coinInDiff / item.gamePlayedDiff).toFixed(2)}}</td>
<td *ngIf="isRoot" class="text-end">

  <button
    class="btn btn-sm btn-outline-primary me-1"
    (click)="moveStatTo(item, 'fusionLease')"
  >
    Move to Lease
  </button>

  <button
    class="btn btn-sm btn-outline-info me-1"
    (click)="moveStatTo(item, 'pickup')"
  >
    Move to Pickup
  </button>

  <button
    class="btn btn-sm btn-outline-dark me-1"
    (click)="moveStatToCategory(item, 'BOARD_SALES')"
  >
    Move to Board Sales
  </button>

  <!-- FLAG BUTTON -->
  <button
    *ngIf="!isFlaggedStat(item)"
    class="btn btn-sm btn-outline-warning me-1"
    (click)="flagStat(item)"
  >
    🚩 Flag
  </button>

  <!-- UNFLAG BUTTON -->
  <button
    *ngIf="isFlaggedStat(item)"
    class="btn btn-sm btn-outline-success me-1"
    (click)="unflagStat(item)"
  >
    ✅ Unflag
  </button>

  <!-- DELETE (existing) -->
  <button
    type="button"
    class="btn btn-sm btn-outline-danger"
    [disabled]="isDeleting[getSerial(item) + '|' + getRowTs(item)]"
    (click)="deleteRow(item)"
  >
    Delete
  </button>

</td>

              </tr>
            </tbody>

          </table>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- Flagged Board Stats Section -->
<div class="row" *ngIf="showStats && flaggedStats.length > 0">
  <div class="col-12">
    <div class="card analytics-card table-card flagged-stats-card">
      <div class="card-body">
        <h4 class="card-title mb-2">Flagged Board Stats</h4>
        <div class="text-muted small mb-3">
          These rows are excluded from Board Stats Analysis totals and averages.
        </div>

        <div class="table-responsive breakdown-table">
          <table class="table table-bordered table-hover" style="min-width: 1200px;">
            <thead>
              <tr class="table-warning totals-row">
                <th class="sticky" colspan="6">
                  <strong>Flagged Totals ({{flaggedStats.length}} Boards)</strong>
                </th>
                <th></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'cashInDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'cashOutDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'profit' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | average:'daysSincePrevRead' | number:'1.0-1'}}</strong></th>
                <th class="sticky"><strong>{{(flaggedStats | average:'cashInDiff/daysSincePrevRead') | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(flaggedStats | average:'profit/daysSincePrevRead') | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(flaggedStats | average:'holdPercentage') * 100 | number:'1.0-2'}}%</strong></th>
                <th class="sticky"><strong>{{((flaggedStats | sum:'coinOutDiff') / (flaggedStats | sum:'coinInDiff')) * 100 | number:'1.0-0'}}%</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'coinInDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'coinOutDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'gamePlayedDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{flaggedStats | sum:'gameWonDiff' | number:'1.0-0'}}</strong></th>
                <th class="sticky"><strong>{{(flaggedStats | sum:'coinInDiff') / (flaggedStats | sum:'cashInDiff') | number:'1.0-2'}}</strong></th>
                <th class="sticky"><strong>{{(flaggedStats | sum:'coinInDiff') / (flaggedStats | sum:'gamePlayedDiff') | number:'1.0-2'}}</strong></th>
                <th *ngIf="isRoot" class="sticky"></th>
              </tr>

              <tr>
                <th (click)="sortData('timeStamp')">Read Timestamp</th>
                <th (click)="sortData('assetTag')">Asset Tag</th>
                <th (click)="sortData('serialNumber')">Serial Number</th>
                <th (click)="sortData('location')">Location</th>
                <th (click)="sortData('salesRep')">Sales Rep</th>
                <th (click)="sortData('salesRep')">State</th>
                <th (click)="sortData('gameName')">Game Name</th>
                <th (click)="sortData('cashIn')">Cash In</th>
                <th (click)="sortData('cashOut')">Cash Out</th>
                <th (click)="sortData('netRevenue')">Net Revenue</th>
                <th (click)="sortData('daysSincePrevRead')">Days Since Last</th>
                <th (click)="sortData('cashIn/day')">Cash In/Day</th>
                <th (click)="sortData('netRevenue/day')">Net/Day</th>
                <th (click)="sortData('payoutPercentage')">Payout %</th>
                <th (click)="sortData('rtp')">RPT</th>
                <th (click)="sortData('coinIn')">Turnover</th>
                <th (click)="sortData('coinOut')">Credit Won</th>
                <th (click)="sortData('gamesPlayed')">Games Played</th>
                <th (click)="sortData('gamesWon')">Games Won</th>
                <th>Bet Multiplier</th>
                <th>Bet/Play</th>
                <th *ngIf="isRoot" class="text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let item of flaggedStats; trackBy: trackByStat"
                class="table-warning"
              >
                <td>{{item.timeStamp | date}}</td>
                <td>
                  <a href="javascript:void(0);" (click)="openBoardStatsModal(item.board?.assetTag)">
                    {{item.board?.assetTag}}
                  </a>
                </td>
                <td>{{item.board?.serialNumber}}</td>
                <td>{{item.__locationName}}</td>
                <td>{{item.__salesRepName}}</td>
                <td>{{item.__state}}</td>
                <td>
                  {{ item.board?.currentDeployment?.installedGamePackage?.name }}

                  <button class="btn btn-sm btn-link text-primary ms-2"
                          (click)="openBoardGameStatsModal(item.id, boardGameStatsModal)">
                    <i class="mdi mdi-eye-outline"></i> View Individual Game Stats
                  </button>

                  <div *ngIf="item.flaggedNote" class="text-danger small">
                    Flagged: {{ item.flaggedNote }}
                  </div>
                </td>
                <td>{{item.cashInDiff.toFixed(0)}}</td>
                <td>{{item.cashOutDiff.toFixed(0)}}</td>
                <td>{{item.profit?.toFixed(0)}}</td>
                <td>{{item.daysSincePrevRead}}</td>
                <td>{{(item.cashInDiff / item.daysSincePrevRead).toFixed(0)}}</td>
                <td>{{(item.profit / item.daysSincePrevRead).toFixed(0)}}</td>
                <td>{{(item.holdPercentage * 100) | number:'1.0-2'}}%</td>
                <td>{{(item.coinOutDiff / item.coinInDiff) * 100 | number:'1.0-0'}}%</td>
                <td>{{item.coinInDiff.toFixed(0)}}</td>
                <td>{{item.coinOutDiff.toFixed(0)}}</td>
                <td>{{item.gamePlayedDiff.toFixed(0)}}</td>
                <td>{{item.gameWonDiff.toFixed(0)}}</td>
                <td>{{(item.coinInDiff / item.cashInDiff).toFixed(2)}}</td>
                <td>{{(item.coinInDiff / item.gamePlayedDiff).toFixed(2)}}</td>
                <td *ngIf="isRoot" class="text-end">
                  <button
                    class="btn btn-sm btn-outline-success me-1"
                    (click)="unflagStat(item)"
                  >
                    Unflag
                  </button>

                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    [disabled]="isDeleting[getSerial(item) + '|' + getRowTs(item)]"
                    (click)="deleteRow(item)"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>


  <!-- Monthly Revenue -->
<div class="row" *ngIf="showTable">
  <div class="row mt-4" *ngIf="showTable">
    <div class="col-12">
      <div class="card analytics-card">
        <div class="card-body">
          <h4 class="card-title mb-4">Revenue Details</h4>
          
          <!-- Loading Spinner -->
          <div *ngIf="isLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <!-- Table Content -->
          <div class="table-responsive" *ngIf="!isLoading">
            <table class="table table-hover align-middle">
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Is Promotional Month</th>
                  <th>Custom Calulations</th>
                  <th>Monthly Payment</th>
                  <th>Amount Paid</th>
                  <th>Number of Machines</th>
                  <th class="text-center">Invoice</th>
                  <th class="text-center">Status</th>
                  <th>Payment</th>
                  <th class="text-center">History</th>
                  <th class="text-center">Contract Expiration Date</th>
                </tr>
              </thead>
<tbody>
  <tr *ngFor="let item of salesReps">
    <td>{{item.firstName}}</td>
    <td>{{item.lastName}}</td>
    <td>
      <div class="form-check">
        <input type="checkbox" 
               class="form-check-input" 
               [(ngModel)]="isFreeMonth[item.id]"
               (change)="onFreeMonthChange(item)"
               [disabled]="loginService.userType === 'EXTERNAL'">
        <label class="form-check-label">Free Month</label>
      </div>
    </td>
    <td>
      <div class="input-group input-group-sm" style="max-width: 150px;">
        <input type="number" 
               class="form-control"
               [(ngModel)]="customDays[item.id]"
               (change)="onCustomDaysChange(item)"
               placeholder="Days"
               [disabled]="loginService.userType === 'EXTERNAL'">
        <span class="input-group-text">days</span>
      </div>
    </td>
<td>{{ getAdjustedMonthlyPayment(item) | currency:'USD' }}</td>
<td>{{ getPaidForRep(item) | currency:'USD' }}</td>





<td>{{ getAdjustedBoardCount(item) }}</td>

    <td class="text-center">
      <button *ngIf="!invoiceService.hasBeenInvoiced(item); else reminderEmailbtn"
              (click)="generateInvoiceForSalesRep(item)"
              class="btn btn-primary btn-sm action-btn"
              [disabled]="loginService.userType === 'EXTERNAL'">
        <i class="fas fa-file-invoice me-1"></i>
        Generate
      </button>
      <ng-template #reminderEmailbtn>
        <button (click)="sendReminderInvoicePDF(item.lastInvoice?.id)"
                class="btn btn-warning btn-sm action-btn"
                [disabled]="loginService.userType === 'EXTERNAL'">
          <i class="fas fa-bell me-1"></i>
          Remind
        </button>
      </ng-template>
    </td>
    <td class="text-center">
      <span class="badge rounded-pill" 
            [ngClass]="{
              'bg-success': getPaymentStatus(item) === 'PAID',
              'bg-warning': getPaymentStatus(item) === 'PARTIAL',
              'bg-secondary': getPaymentStatus(item) === 'PENDING'
            }">
        {{getPaymentStatus(item)}}
      </span>
    </td>
    <td>
      <div class="input-group input-group-sm payment-input-group">
        <input type="number" 
               class="form-control"
               [(ngModel)]="paymentAmounts[item.id]"
               placeholder="Enter payment amount"
               [disabled]="loginService.userType === 'EXTERNAL'">
        <button class="btn btn-success" 
                (click)="recordPayment(item)"
                [disabled]="loginService.userType === 'EXTERNAL' || !paymentAmounts[item.id]">
          <i class="fas fa-check"></i>
        </button>
      </div>
    </td>                              
    <td class="text-center">
      <button class="btn btn-info" title="View Payment History" 
              (click)="showPaymentHistory(item)">
        <i class="fas fa-history me-1"></i>
        History
      </button>
    </td>
    <td class="text-center">
      <button class="btn btn-info btn-sm action-btn" 
              (click)="showLocationEndDates(item)">
        <i class="fas fa-history me-1"></i>
        End Dates
      </button>
    </td>
  </tr>
  <tr class="table-info font-weight-bold">
    <td colspan="2"><strong>Totals</strong></td>
    <td></td> <!-- Free Month column -->
    <td></td> <!-- Custom Days column -->
    <td><strong>{{getTotalMonthlyPayment() | currency:'USD'}}</strong></td>
    <td><strong>{{getTotalAmountPaid() | currency:'USD'}}</strong></td>
    <td><strong>{{getTotalMachines()}}</strong></td>
    <td colspan="5"></td>
  </tr>
</tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <ng-template #paymentHistoryModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Payment History - {{selectedSalesRep?.firstName}} {{selectedSalesRep?.lastName}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payment of paymentHistory">
            <td>{{payment.paymentDate | date:'medium'}}</td>
            <td>{{payment.amount | currency:'USD'}}</td>
            <td class="text-center">
              <span class="badge rounded-pill" 
                    [ngClass]="{
                      'bg-success': payment.status === 'PAID',
                      'bg-warning': payment.status === 'PARTIAL',
                      'bg-secondary': payment.status === 'PENDING'
                    }">
                {{payment.status}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-template>
  <ng-template #locationEndDatesModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Location End Dates - {{selectedSalesRep?.firstName}} {{selectedSalesRep?.lastName}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Location Tag</th>
              <th>Number of Machines</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let location of selectedSalesRepLocations">
              <td>{{location.locationName}}</td>
              <td>{{location.locationTag}}</td>
              <td>{{location.numBoards}}</td>
              <td>{{formatDate(location.locationStartDate)}}</td>
              <td>
                <span [ngClass]="{
                  'text-warning': isDateApproaching(location.locationEndDate),
                  'text-danger': isDateExpired(location.locationEndDate)
                }">
                  {{formatDate(location.locationEndDate)}}
                </span>
              </td>
              <td>
                <span class="badge rounded-pill" 
                      [ngClass]="{
                        'bg-success': !location.locationEndDate,
                        'bg-warning': isDateApproaching(location.locationEndDate),
                        'bg-danger': isDateExpired(location.locationEndDate)
                      }">
                  {{!location.locationEndDate ? 'Active' : 
                    isDateExpired(location.locationEndDate) ? 'Expired' :
                    isDateApproaching(location.locationEndDate) ? 'Expiring Soon' : 'Active'}}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="selectedSalesRepLocations.length === 0" class="text-center p-4">
          <p class="text-muted">No active locations found for this sales rep.</p>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #boardGameStatsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Board Game Stats - {{selectedBoardAssetTag}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" style="max-width: 100vw; overflow-x: auto;">
      <div *ngIf="isLoadingGameStats" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
  
      <!-- START: Fixed block -->
      <div *ngIf="!isLoadingGameStats && boardGameStatsList.length">
        <div class="table-responsive">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Game Name</th>
                <th>Turn Over</th>
                <th>Credit Won</th>
                <th>Net</th>
                <th>Games Played</th>
                <th>Games Won</th>
                <th>Win Ratio</th>
                <th>RPT</th>
                <th>Avg Bet</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let stat of boardGameStatsList; trackBy: trackByStat">
                <td>{{ stat.game?.gameName || stat.gameStatsId?.gameId }}</td>
                <td>{{ stat.coinInDiff | number:'1.0-0' }}</td>
                <td>{{ stat.coinOutDiff | number:'1.0-0' }}</td>
                <td>{{ (stat.coinInDiff - stat.coinOutDiff) | number:'1.0-0' }}</td>
                <td>{{ stat.gamePlayedDiff }}</td>
                <td>{{ stat.gameWonDiff }}</td>
                <td>{{ (stat.gamePlayedDiff ? (stat.gameWonDiff / stat.gamePlayedDiff * 100) : 0) | number:'1.0-0' }}%</td>
                <td>{{ (stat.coinInDiff ? (stat.coinOutDiff / stat.coinInDiff * 100) : 0) | number:'1.0-1' }}%</td>
                <td>{{ (stat.gamePlayedDiff ? (stat.coinInDiff / stat.gamePlayedDiff) : 0) | number:'1.1-1' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-info">
                <td><strong>Total</strong></td>
                <td><strong>{{ getTotalCoinIn() | number:'1.0-0' }}</strong></td>
                <td><strong>{{ getTotalCoinOut() | number:'1.0-0' }}</strong></td>
                <td><strong>{{ getTotalNet() | number:'1.0-0' }}</strong></td>
                <td><strong>{{ getTotalGamesPlayed() }}</strong></td>
                <td><strong>{{ getTotalGamesWon() }}</strong></td>
                <td><strong>{{ getTotalWinRatio() | number:'1.0-0' }}%</strong></td>
                <td><strong>{{ getTotalRPT() | number:'1.0-1' }}%</strong></td>
                <td><strong>{{ getAvgBet() | number:'1.1-1' }}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!-- END: missing closing div added above -->
  
      <div *ngIf="!isLoadingGameStats && boardGameStatsList.length === 0" class="text-center text-muted">
        No game stats available for this board.
      </div>
    </div>
  </ng-template>

  <!-- Existing revenue/collection cards... -->

<!-- Loading spinner -->
<!-- Show Leads Section -->
<div *ngIf="showLeadsPage" class="card">

  <!-- Header always visible -->
  <div class="card-header">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h5 class="mb-0">Lead Management</h5>
      <button (click)="openLeadModal()" class="btn btn-primary">+ Add Lead</button>
    </div>
  </div>

<!-- Modal stays separate and visible independently -->
      <app-lead-modal
        *ngIf="showLeadModal"
        [lead]="selectedLead"
        (save)="saveLead($event)"
        (close)="showLeadModal = false; selectedLead = null">
      </app-lead-modal>


  <!-- Table visible when showLeadsTable is true -->
<div *ngIf="showLeadsTable" class="card-body p-0">
  <div class="leads-table-container">
    <table class="table leads-table">
      <thead>
        <tr>
          <th>Business</th>
          <th>Status</th>
          <th>Sales Rep</th>
          <th>Interested</th>
          <th>Closed</th>
          <th>Expected Delivery</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lead of filteredLeads; trackBy: trackByLead">
          <td>{{ lead.businessName }}</td>
          <td>
            <span class="badge"
              [ngClass]="{
                'bg-secondary': lead.status === 'NEW' || lead.status === 'CLOSED',
                'bg-warning': lead.status === 'CONTACTED',
                'bg-info': lead.status === 'IN_PROGRESS',
                'bg-success': lead.status === 'WON',
                'bg-danger': lead.status === 'LOST'
              }">
              {{ lead.status }}
            </span>
          </td>
          <td>{{ getSalesRepName(lead.assignedSalesRepId) }}</td>
          <td>{{ lead.interestedMachineCount }}</td>
          <td>{{ lead.closedMachineCount }}</td>
          <td>{{ lead.expectedDeliveryDate | date }}</td>
          <td>
            <button class="btn btn-sm btn-outline-secondary" (click)="editLead(lead)">Edit</button>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteLead(lead.id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- Mobile Cards: visible only on sm and down -->
<div class="card-body d-block d-md-none">
  <div *ngFor="let lead of filteredLeads; trackBy: trackByLead" class="lead-card">
    <div class="lead-field"><strong>Business:</strong> {{ lead.businessName }}</div>
    <div class="lead-field"><strong>Status:</strong>
      <span class="badge"
        [ngClass]="{
          'bg-secondary': lead.status === 'NEW' || lead.status === 'CLOSED',
          'bg-warning': lead.status === 'CONTACTED',
          'bg-info': lead.status === 'IN_PROGRESS',
          'bg-success': lead.status === 'WON',
          'bg-danger': lead.status === 'LOST'
        }">
        {{ lead.status }}
      </span>
    </div>
    <div class="lead-field"><strong>Sales Rep:</strong> {{ getSalesRepName(lead.assignedSalesRepId) }}</div>
    <div class="lead-field"><strong>Interested:</strong> {{ lead.interestedMachineCount }}</div>
    <div class="lead-field"><strong>Closed:</strong> {{ lead.closedMachineCount }}</div>
    <div class="lead-field"><strong>Expected Delivery:</strong> {{ lead.expectedDeliveryDate | date }}</div>
    <div class="mt-2 d-flex gap-2">
      <button class="btn btn-sm btn-outline-secondary" (click)="editLead(lead)">Edit</button>
      <button class="btn btn-sm btn-outline-danger" (click)="deleteLead(lead.id)">Delete</button>
    </div>
  </div>
</div>

</div>



  
  
          

  <!-- Location Page -->
<div class="row" *ngIf="showLocationPage" id="location-management-section">
  <div class="col-12">
    <div class="card analytics-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Location Management</h4>

        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">City</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="locationCityFilter"
              placeholder="Filter by city">
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">State</label>
            <select
              class="form-select form-select-sm"
              [(ngModel)]="locationStateFilter">
              <option value="">All</option>
              <option *ngFor="let st of locationStateOptions" [value]="st.toLowerCase()">{{ st }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">Min Machines</label>
            <input
              type="number"
              class="form-control form-control-sm"
              [(ngModel)]="locationMinMachines"
              placeholder="e.g. 5">
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">Sort By</label>
            <div class="input-group input-group-sm">
              <select class="form-select" [(ngModel)]="locationSortColumn">
                <option value="">None</option>
                <option value="machines"># Machines</option>
                <option value="city">City</option>
                <option value="state">State</option>
              </select>
              <button class="btn btn-outline-secondary" type="button" (click)="locationSortAsc = !locationSortAsc">
                <i class="fas" [ngClass]="locationSortAsc ? 'fa-sort-amount-up-alt' : 'fa-sort-amount-down-alt'"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Count Tag</th>
                <th>Name</th>
                <th>Number of Machines</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>ZIP</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <!-- Only non-sales-outlet locations are shown -->
              <tr *ngFor="let location of displayLocations">
                <td>{{ location.locationTag }}</td>
                <td>{{ location.locationName }}</td>

                <!-- Number of Machines (wrapped in a TD) -->
                <td>
                  <!-- Link only if not TECH -->
                  <a
                    *ngIf="location.numBoards > 0 && currentUserType !== 'TECH'"
                    href="javascript:void(0)"
                    class="board-count-link"
                    (click)="showLocationBoardStats(location, boardStatsModal)"
                  >
                    {{ location.numBoards }}
                  </a>

                  <!-- Number only if TECH -->
                  <span *ngIf="location.numBoards > 0 && currentUserType === 'TECH'">
                    {{ location.numBoards }}
                  </span>

                  <!-- 0 case -->
                  <span *ngIf="!location.numBoards || location.numBoards === 0">0</span>
                </td>

                <td>{{ location?.businessAddress?.streetAddress1 }}</td>
                <td>{{ location?.businessAddress?.city }}</td>
                <td>{{ location?.businessAddress?.state }}</td>
                <td>{{ location?.businessAddress?.zip }}</td>
                <td>
                  <span class="badge" [ngClass]="location.enabled ? 'bg-success' : 'bg-danger'">
                    {{ location.enabled ? 'Active' : 'Inactive' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


  
<!-- Board Inventory Table -->
<div class="row" *ngIf="showBoardInventoryPage">
  <div class="col-12">
    <div class="card analytics-card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4 class="card-title mb-0">Board Inventory Locations</h4>
          <span class="badge bg-primary">Total Boards: {{ boardInventoryTotalBoards }}</span>
        </div>
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th>Location</th>
                <th>Address</th>
                <th class="text-center">Boards Available</th>
                <th>Board Types</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of boardInventoryLocations; trackBy: trackByLocation">
                <td class="fw-semibold text-uppercase">{{ loc.locationName }}</td>
                <td>
                  <div>{{ loc.businessAddress?.streetAddress1 }}</div>
                  <div class="text-muted small">
                    {{ loc.businessAddress?.city }}
                    <span *ngIf="loc.businessAddress?.city && loc.businessAddress?.state">, </span>
                    {{ loc.businessAddress?.state }}
                    <span *ngIf="loc.businessAddress?.zip">&nbsp;{{ loc.businessAddress?.zip }}</span>
                  </div>
                </td>
                <td class="text-center fw-bold">{{ loc.numBoards || 0 }}</td>
                <td>
                  <ng-container *ngIf="getBoardTypeCountsForLocation(loc) as typeCounts">
                    <ng-container *ngIf="typeCounts.length; else emptyTypes">
                      <div class="d-flex flex-wrap gap-2">
                        <span class="badge bg-light text-dark border" *ngFor="let t of typeCounts">
                          <span class="fw-semibold">{{ t.type }}</span>: {{ t.count }}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
              <tr *ngIf="boardInventoryLocations.length === 0">
                <td colspan="4" class="text-center text-muted">No board inventory locations found.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #emptyTypes>
          <span class="text-muted">-</span>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Warehouse Table -->
<div class="row" *ngIf="showWarehousePage">
  <div class="col-12">
    <div class="card analytics-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Warehouse Inventory</h4>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Contract Tag</th>
                <th>Company Name</th>
                <th>Machines Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredLocation">
                <td>{{item.locationTag}}</td>
                <td>{{item.locationName}}</td>
                <td>{{item.numBoards}}</td>
              </tr>
              <tr *ngIf="lostInventoryLocation" class="table-active">
                <td colspan="3" class="fw-semibold text-uppercase">Lost Inventory </td>
              </tr>
              <tr *ngIf="lostInventoryLocation" class="table-warning">
                <td>{{ lostInventoryLocation.locationTag }}</td>
                <td>{{ lostInventoryLocation.locationName }}</td>
                <td>{{ lostInventoryBoardCount || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- New Locations Table -->
<div class="row" *ngIf="showNewLocationPage">
  <div class="col-12">
    <div class="card analytics-card">
      <div class="card-body">
        <h4 class="card-title mb-4">New Locations</h4>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Contract Tag</th>
                <th>Company Name</th>
                <th>Machines Count</th>
                <th>Sales Rep</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredNewLocations">
                <td>{{item.locationTag}}</td>                
                <td>{{item.locationName}}</td>
                <td>{{item.numBoards}}</td>
                <td>{{item.salesRep?.firstName}} {{item.salesRep?.lastName}}</td>
                <td>{{item.businessAddress.streetAddress1}}</td>
                <td>{{item.businessAddress.city}}</td>
                <td>{{item.businessAddress.state}}</td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Top Games Breakdown Table -->
<div class="row" *ngIf="showSalesOutletPage">
  <div class="col-12">
    <div class="card analytics-card">
      <div class="card-body">
        <h4 class="card-title mb-4">Board Sales</h4>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Location</th>
                <th>Boards Sold</th>
                <th>Board Price</th>
                <th>Total Value</th>
                <th>Paid?</th>
                <th>Amount Paid</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of salesOutletLocations">
                <td>{{ loc.locationName }}</td>
                <td>{{ loc.numBoards || 0 }}</td>
                <td style="max-width: 120px;">
                  <input type="number"
                         class="form-control form-control-sm"
                         min="0"
                         step="0.01"
                         [ngModel]="getSalesOutletBoardPrice(loc)"
                         (ngModelChange)="onSalesOutletPriceChange(loc, $event)">
                </td>
                <td>{{ getSalesOutletRowTotal(loc) | currency:'USD' }}</td>
                <td>
                  <div class="form-check form-switch">
                    <input type="checkbox"
                           class="form-check-input"
                           [checked]="isSalesOutletPaid(loc)"
                           (change)="onSalesOutletPaidToggle(loc, $event.target.checked)">
                    <label class="form-check-label">
                      {{ isSalesOutletPaid(loc) ? 'Paid' : 'Unpaid' }}
                    </label>
                  </div>
                </td>
                <td style="max-width: 140px;">
                  <input type="number"
                         class="form-control form-control-sm"
                         min="0"
                         step="0.01"
                         [ngModel]="getSalesOutletPaidAmount(loc)"
                         (ngModelChange)="onSalesOutletPaidAmountChange(loc, $event)">
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-info">
                <td><strong>Total</strong></td>
                <td><strong>{{ salesOutletBoardsCount }}</strong></td>
                <td></td>
                <td><strong>{{ salesOutletTotalValue | currency:'USD' }}</strong></td>
                <td></td>
                <td><strong>{{ salesOutletTotalPaidAmount | currency:'USD' }}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Top Games Breakdown Table -->
<div *ngIf="showTopGameStats" class="table-responsive">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th></th>
        <th>Game Name</th>
        <!-- <th>Installed Package</th> -->
        <th># Boards</th> <!-- = NEW -->
        <th>Avg Coin/Day/Board</th>
        <th>Total Coin In</th>
        <th>Total Coin Out</th>
        <th>Net</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let game of topGameStats; trackBy: trackByTopGame">
        <!-- Main row -->
        <tr (click)="loadGameBreakdown(game.gameName)">
          <td>
            <i class="fas"
               [ngClass]="{
                 'fa-chevron-down': expandedGameName === game.gameName,
                 'fa-chevron-right': expandedGameName !== game.gameName
               }">
            </i>
          </td>
          <td>{{ game.gameName }}</td>
          <!-- <td>{{ packageByGame[game.gameName] || 'N/A' }}</td> -->
           <td>{{ boardsPerGame[game.gameName] || 0 }}</td> <!-- = NEW -->
         <td>
  <ng-container *ngIf="!avgCoinPerDayLoading; else loadingAvg">
    {{ avgCoinPerDayByGame[game.gameName] | number:'1.0-2' }}
  </ng-container>
  <ng-template #loadingAvg>G</ng-template>
</td>

<td>{{ (cleanTotalsByGame[game.gameName]?.coinIn  ?? game.totalCoinIn)  | number:'1.0-0' }}</td>
<td>{{ (cleanTotalsByGame[game.gameName]?.coinOut ?? game.totalCoinOut) | number:'1.0-0' }}</td>
<td>{{ (cleanTotalsByGame[game.gameName]?.net     ?? game.netProfit)    | number:'1.0-0' }}</td>

        </tr>

        <!-- Expandable breakdown rows -->
        <tr *ngIf="expandedGameName === game.gameName">
          <td colspan="8">
            <div class="table-responsive">
              <table class="table table-sm table-striped mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th>Asset Tag</th>
                    <th>Serial #</th>
                    <th>Location</th>
                    <th>Sales Rep</th>
                    <th>Coin In</th>
                    <th>Coin Out</th>
                    <th>Net</th>
                    <th>Games Played</th>
                    <th>Games Won</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let boardGroup of selectedGroupedBreakdowns[game.gameName]; trackBy: trackByBoardGroup">
                    <!-- Summary Row -->
                  <tr (click)="onToggleBoardGroup(boardGroup, game.gameName)">

                      <td>
                        <i class="fas"
                           [ngClass]="{
                             'fa-chevron-down': boardGroup.expanded,
                             'fa-chevron-right': !boardGroup.expanded
                           }">
                        </i>
                      </td>
                      <td>{{ boardGroup.summary.boardAssetTag }}</td>
                      <td>{{ boardGroup.summary.boardSerialNumber }}</td>
                      <td>{{ boardGroup.summary.locationName }}</td>
                      <td>{{ boardGroup.summary.salesRepName }}</td>
                      <td>{{ boardGroup.summary.coinIn }}</td>
                      <td>{{ boardGroup.summary.coinOut }}</td>
                      <td>{{ boardGroup.summary.net }}</td>
                      <td>{{ boardGroup.summary.gamesPlayed }}</td>
                      <td>{{ boardGroup.summary.gamesWon }}</td>
                    </tr>

                    <!-- Detail Rows -->
                    <tr *ngIf="boardGroup.expanded">
                      <td colspan="10" class="p-0">
                        <div class="table-responsive">
                          <table class="table table-sm table-bordered mb-0">
                            <thead>
                              <tr class="table-light">
                                <th>Date</th>
                                <th>Days Since Read</th>
                                <th>Coin In</th>
                                <th>Coin Out</th>
                                <th>Net</th>
                                <th>Games Played</th>
                                <th>Games Won</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let read of boardGroup.details; trackBy: trackByRead">
                                <td>{{ read.timeStamp | date: 'short' }}</td>
                                <td>{{ read.daysSincePrevRead }}</td>
                                <td>{{ read.coinIn }}</td>
                                <td>{{ read.coinOut }}</td>
                                <td>{{ read.net }}</td>
                                <td>{{ read.gamesPlayed }}</td>
                                <td>{{ read.gamesWon }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>




<!-- Board Stats Modal -->
  <ng-template #boardStatsModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Board Statistics - {{selectedLocation?.locationName}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="loading-spinner" *ngIf="isLoadingLocationStats">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!isLoadingLocationStats">
        <table class="table table-hover">
        <thead>
          <tr>
            <th>Time Stamp</th>
            <th>Asset Tag</th>
            <th>Game Name</th>
            <th class="text-end">Cashcddd In</th>
            <th class="text-end">Cash Out</th>
            <th class="text-end">Net Revenue</th>
            <th class="text-end">Games Played</th>
            <th class="text-end">Games Won</th>
            <th class="text-end">Hold %</th>
            <th class="text-end">Days Since Last</th>
            <th class="text-end">Cash In/Day</th>
            <th class="text-end">Net/Day</th>
            <th *ngIf="isRoot" class="text-end">Actions</th> <!-- NEW -->
          </tr>
        </thead>
          <tbody>
            <tr *ngFor="let stats of locationBoardStats; trackBy: trackByStat">
              <td>{{stats.timeStamp | date:'yyyy-MM-dd HH:mm:ss.SSSSSS'}}</td>
              <td>
                <a href="javascript:void(0);" (click)="openBoardStatsModal(stats.board?.assetTag)">
                  {{stats.board?.assetTag}}
                </a>
              </td>
              <td>{{stats.board?.installedGamePackage?.name}}</td>
              <td class="text-end">{{stats.cashInDiff | currency}}</td>
              <td class="text-end">{{stats.cashOutDiff | currency}}</td>
              <td class="text-end" [ngClass]="{'text-success': stats.profit > 0, 'text-danger': stats.profit < 0}">
                {{stats.profit | currency}}
              </td>
              <td class="text-end">{{stats.gamePlayedDiff}}</td>
              <td class="text-end">{{stats.gameWonDiff}}</td>
              <td class="text-end">{{stats.holdPercentage | percent:'1.1-2'}}</td>
              <td class="text-end">{{stats.daysSincePrevRead}}</td>
              <td class="text-end">{{(stats.cashInDiff / stats.daysSincePrevRead) | currency}}</td>
              <td class="text-end">{{(stats.profit / stats.daysSincePrevRead) | currency}}</td>

              <!-- NEW: Delete button -->
              <td *ngIf="isRoot" class="text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  [disabled]="isDeleting[getSerial(stats) + '|' + getRowTs(stats)]"
                  (click)="deleteRow(stats)"
                  title="Delete this stat">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
                    <!-- <tfoot *ngIf="locationBoardStats.length > 0">
            <tr class="table-info">
              <td colspan="3"><strong>Totals</strong></td>
              <td class="text-end"><strong>{{locationBoardStats | sum:'cashInDiff' | currency}}</strong></td>
              <td class="text-end"><strong>{{locationBoardStats | sum:'cashOutDiff' | currency}}</strong></td>
              <td class="text-end" [ngClass]="{'text-success': (locationBoardStats | sum:'profit') > 0, 'text-danger': (locationBoardStats | sum:'profit') < 0}">
                <strong>{{locationBoardStats | sum:'profit' | currency}}</strong>
              </td>
              <td class="text-end"><strong>{{locationBoardStats | sum:'gamePlayedDiff'}}</strong></td>
              <td class="text-end"><strong>{{locationBoardStats | sum:'gameWonDiff'}}</strong></td>
              <td class="text-end"><strong>{{(locationBoardStats | average:'holdPercentage') | percent:'1.1-2'}}</strong></td>
              <td></td>
              <td class="text-end"><strong>{{(locationBoardStats | average:'cashInDiff/daysSincePrevRead') | currency}}</strong></td>
              <td class="text-end"><strong>{{(locationBoardStats | average:'profit/daysSincePrevRead') | currency}}</strong></td>
            </tr>
          </tfoot> -->
        </table>
        <div *ngIf="locationBoardStats.length === 0" class="text-center p-4">
          <p class="text-muted">No active board statistics available for this location.</p>
        </div>
      </div>
    </div>
  </ng-template>
  
